import { useLayoutEffect } from 'react';

// Fit to the reader's actual box, including embedded and resized windows.
// Below the readable minimum, scroll inside the poem instead of clipping it.
export default function useFitPoem(ref, mode) {
  useLayoutEffect(() => {
    const reader = ref.current;
    if (!reader) return;
    let frame;
    const fit = () => {
      if (!reader.clientHeight || !reader.clientWidth) return;
      reader.style.overflowY = 'hidden';
      const min = 12;
      let low = min;
      let high = window.innerWidth <= 480 ? 14 : 18;
      const fits = (size) => {
        reader.style.fontSize = `${size}px`;
        return reader.scrollHeight <= reader.clientHeight + 1 &&
          reader.scrollWidth <= reader.clientWidth + 1;
      };
      if (!fits(min)) {
        reader.style.overflowY = 'auto';
      } else {
        for (let i = 0; i < 10; i += 1) {
          const middle = (low + high) / 2;
          if (fits(middle)) low = middle;
          else high = middle;
        }
        fits(Math.floor(low * 100) / 100);
      }
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fit);
    };
    fit();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(schedule);
    observer?.observe(reader);
    window.addEventListener('resize', schedule);
    document.fonts?.addEventListener('loadingdone', schedule);
    return () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('resize', schedule);
      document.fonts?.removeEventListener('loadingdone', schedule);
    };
  }, [ref, mode]);
}
